import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PatientInformationConstants } from '../../patientInformation/store/patientInformation.constants'
import { IPcr } from '../../pcr/store/pcr.types'
import { setPatientMedicalHistory } from '../store/patientMedicalHistory.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'

export function* getPatientMedicalHistory(pcrDoc: IPcr) {
  const patientMedicalHistory = pcrDoc.patient?.patientMedicalHistory
  if (patientMedicalHistory && Object.keys(patientMedicalHistory).length !== 0) {
    yield put(setPatientMedicalHistory(patientMedicalHistory))
  }
}

export function* preloadPCR() {
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (!pcrID) return

  try {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    yield call(getPatientMedicalHistory, pcrDoc)
  } catch (e) {
    yield put(throwPcrException(`preloadPCR() error in getPatientMedicalHistory.saga.ts: ${e}`))
  }
}

export function* getPatientMedicalHistorySaga() {
  yield takeLatest([PatientInformationConstants.REFRESH_PATIENT_DATA], performWithMutexHOG, preloadPCR)
}
